export function buildReportFetchParams({
  page = 1,
  perPage,
  filterDate,
  searchTerm,
  overrides = {},
}) {
  const params = { page, perPage, ...overrides };

  if (filterDate?.[0] && filterDate?.[1]) {
    params.SD = filterDate[0];
    params.ED = filterDate[1];
  }

  if (searchTerm?.trim()) {
    params.search = searchTerm.trim();
  }

  return params;
}

export function refetchReportWithoutSearch({ filterDate, perPage, fetchData }) {
  fetchData(
    buildReportFetchParams({
      page: 1,
      perPage,
      filterDate,
      searchTerm: "",
    })
  );
}

export function resetReportFilters({
  todayDateString,
  perPage,
  setSearchTerm,
  setFilterDate,
  fetchData,
}) {
  const clearedDates = [todayDateString, todayDateString];
  setSearchTerm("");
  setFilterDate(clearedDates);
  fetchData(
    buildReportFetchParams({
      page: 1,
      perPage,
      filterDate: clearedDates,
      searchTerm: "",
    })
  );
}
